import { useContext, useEffect, useState } from "react";
import { AdminPersonsResponse, AdminQueryApprovers } from "../../../backend/src/api/dto";
import { AdminAddApproverToUserFunction, AdminReloadFunction } from "../interfaces";
import API from "../API";
import { useForm } from "react-hook-form";
import { ModalContext } from "../ModalContext";
import Modal from ".";


type FormValues = {
    password: string
}



function AdminChangeUserPassword({ changeFunction }: {
    changeFunction: Function,

}) {
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [data, setData] = useState<AdminPersonsResponse>();
    const [apiResult, setApiResult] = useState<null | { status: boolean, message?: string }>(null)

    const [showModal, closeModal] = useContext(ModalContext);
    const { register, control, handleSubmit, getValues, setValue } = useForm<FormValues>()


    useEffect(() => {
        API.getPersons({}).then(data => {
            setData(data)
        })
    }, [])

    const modalButtons = [
        {
            text: 'Confirm',
            icon: 'check',
            onClick: () => onSubmit(),

            style: 'primary'
        }, {
            text: 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    const generate = () => {
        setValue('password', (Math.random() + 1).toString(36).substring(2))
    }

    const onSubmit = () => {
        const form = getValues();


        setSending(true);
        return new Promise((resolve, reject) => {
            handleSubmit((data) => {
                //  console.log({ data: getValues() })

// 
                setLoading(false);
                setApiResult({
                    status: true,
                    message: 'ok'
                })
                changeFunction(data.password).catch((e: any) => {
                    setLoading(false);
                    setApiResult(e)
                    resolve(1)
                })



                setSending(false)
            })()
        })

    }





    return (



        <Modal
            buttons={modalButtons}
            title={'Zmeniť heslo'}
            errorObject={apiResult}
            disableAllButtons={sending}
        >
            <div >


                <div className="row">
                    <div className="col-3 mt-1 text-end">
                        <label className="form-label mt-1">Heslo</label>
                    </div>
                    <div className="col-9">
                        <div className="input-group mb-3">
                            <input type="text" {...register("password")} className="form-control" />
                            <button onClick={generate} className="btn btn-primary">Vygenerovať</button>
                        </div>
                    </div>
                </div>


            </div>
        </Modal>


    )

}

export default AdminChangeUserPassword
